/**
 * Las marcas del catálogo, juntas sin distinguir mayúsculas ni espacios.
 *
 * `GET /scope/brands` agrupa por el texto crudo: «SONY» y «Sony» salen
 * separadas (vienen de lectores distintos). El motor las compara normalizadas
 * (`alcance-regla.ts:normal`), así que guardar una sola escritura alcanza a
 * todas. Se muestra la escritura con más productos.
 */
export interface MarcaAgrupada {
  name: string;
  count: number;
  variantes: string[];
}

export const normalMarca = (s: string) => s.trim().toLocaleLowerCase('es');

export function agruparMarcas(brands: Array<{ name: string; count: number }>): MarcaAgrupada[] {
  const porClave = new Map<
    string,
    { total: number; mejor: { name: string; count: number }; variantes: string[] }
  >();
  for (const b of brands) {
    const clave = normalMarca(b.name);
    if (clave === '') continue;
    const g = porClave.get(clave);
    if (!g) {
      porClave.set(clave, { total: b.count, mejor: b, variantes: [b.name] });
      continue;
    }
    g.total += b.count;
    g.variantes.push(b.name);
    if (b.count > g.mejor.count) g.mejor = b;
  }
  return [...porClave.values()]
    .map((g) => ({ name: g.mejor.name.trim(), count: g.total, variantes: g.variantes }))
    .sort((a, b) => b.count - a.count || a.name.localeCompare(b.name, 'es'));
}
